import React from 'react';
import { Tooltip, Whisper, Icon } from 'rsuite';
import PropTypes from 'prop-types';
import { ColorActionLabels } from '../../../constants/storage';

const StorageActionTooltip = ({ value, ...props }) => (
  <Tooltip {...props}>Action Indicator: {ColorActionLabels[value]}</Tooltip>
);

StorageActionTooltip.propTypes = {
  value: PropTypes.number.isRequired
};

export default () => (
  <div>
    <Whisper
      placement="top"
      trigger="hover"
      speaker={<StorageActionTooltip value={1} />}
    >
      <Icon
        icon="circle"
        style={{
          color: '#7ED321'
        }}
      />
    </Whisper>
  </div>
);
